import { createContext } from 'react';

/**
 * Provides the form-level licensee ID to descendant components.
 * RemoteAutocomplete reads this to inject franchise_to into API queries.
 * Value: licensee ID (number) or null.
 */
const FormLicenseeContext = createContext(null);
FormLicenseeContext.displayName = 'FormLicenseeContext';

/** Normalize tour_operator from API (may be {id,name} object) to a plain ID. */
export const toLicenseeId = (value) =>
    value != null && typeof value === 'object' ? value.id : value;

export default FormLicenseeContext;
